import UserInterface, {CooloffInterface} from 'app/interfaces/UserInterface';


export const isCoolOffActiveFor = (cool_off: CooloffInterface, productTypes: string[] = []): boolean => {
    if (!cool_off) {
        return false;
    }
    return productTypes.includes(cool_off.product_type) || cool_off.product_type === 'all_products';
};

export const coolOffLootbox = (user: UserInterface): boolean => isCoolOffActiveFor(user?.cool_off, ['lootboxes']);

export const coolOffSportBets = (user: UserInterface): boolean => isCoolOffActiveFor(user?.cool_off, ['sports_bets']);

export const coolOffCybersportBets = (user: UserInterface): boolean => isCoolOffActiveFor(user?.cool_off, ['cybersport_bets']);

export const coolOffCasino = (user: UserInterface): boolean => isCoolOffActiveFor(user?.cool_off, ['casino']);

export const coolOffPoker = (user: UserInterface): boolean => isCoolOffActiveFor(user?.cool_off, ['poker']);
